import {
  AuthCode,
  FlexBox,
  JoonColorExpanded,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useChildAuthCodeQuery } from "../../networking/queries"

const ChildAuthCode = () => {
  const { data: authCode } = useChildAuthCodeQuery()
  const { t } = useTranslation()
  return (
    <FlexBox
      gap={SPACING.space2}
      align="center"
      style={{ paddingBottom: SPACING.space3, width: "fit-content" }}
    >
      <Typography variant="bodyBold" color={JoonColorExpanded.indigo700}>
        {t("CHILD_LOGIN_CODE")}{" "}
      </Typography>
      <AuthCode
        code={authCode || ""}
        style={{ color: JoonColorExpanded.indigo700 }}
      />
    </FlexBox>
  )
}

export default ChildAuthCode
